/**
 * The one-time set-password link, shown after a user or staff member is
 * created. Credential-equivalent by contract: displayed once, never stored,
 * never logged — the same rules as every other surface that touches it.
 */
import { useRef, useState } from 'react';

export function InvitePanel({
  email,
  link,
  account,
  onDone,
}: {
  email: string;
  link: string;
  account?: string;
  onDone: () => void;
}) {
  const [copied, setCopied] = useState(false);
  const ref = useRef<HTMLInputElement>(null);

  return (
    <div className="panel" style={{ marginBottom: 14 }}>
      <div className="panel__head">
        <h2>Send this to {email}</h2>
        <div className="spacer" />
        <button className="btn btn--sm" onClick={onDone}>
          Done
        </button>
      </div>
      <div className="panel__body">
        <p className="note" style={{ marginBottom: 12 }}>
          This link lets them set their own password. It is shown once and is not stored anywhere — copy it now.{' '}
          {account === 'existing' && (
            <b>This email already had a sign-in account, so the existing one was linked rather than a new one created.</b>
          )}
        </p>
        <div className="field">
          <label htmlFor="invite-link">Set-password link</label>
          <input id="invite-link" ref={ref} type="text" readOnly spellCheck={false} value={link} />
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          <button
            className="btn btn--primary"
            onClick={() => {
              ref.current?.select();
              void navigator.clipboard
                .writeText(link)
                .then(() => {
                  setCopied(true);
                  setTimeout(() => setCopied(false), 1500);
                })
                .catch(() => undefined); // selection stays; copy by hand
            }}
          >
            {copied ? 'Copied' : 'Copy link'}
          </button>
        </div>
      </div>
    </div>
  );
}
